module.exports = __webpack_public_path__ + "img/print_bg_img_001.adf003c5.png";